/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_qr_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Turn any text or link into a QR code and download it as a PNG. Everything runs in your browser — nothing is uploaded.`)
};

const es_qr_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Convierte cualquier texto o enlace en un código QR y descárgalo como PNG. Todo se ejecuta en tu navegador — no se sube nada.`)
};

const de_qr_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wandle beliebigen Text oder Link in einen QR-Code um und lade ihn als PNG herunter. Alles läuft in deinem Browser — nichts wird hochgeladen.`)
};

const nl_qr_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zet tekst of een link om in een QR-code en download hem als PNG. Alles gebeurt in je browser — er wordt niets geüpload.`)
};

const fr_qr_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Transformez n'importe quel texte ou lien en QR code et téléchargez-le en PNG. Tout se passe dans votre navigateur — rien n'est envoyé sur un serveur.`)
};

const it_qr_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trasforma qualsiasi testo o link in un codice QR e scaricalo come PNG. Tutto avviene nel tuo browser — niente viene caricato online.`)
};

const pt_br2_qr_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Transforme qualquer texto ou link em um código QR e baixe como PNG. Tudo roda no seu navegador — nada é enviado para servidores.`)
};

const pt_qr_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Transforme qualquer texto ou link num código QR e descarregue-o em PNG. Tudo acontece no seu navegador — nada é enviado para nenhum servidor.`)
};

const ja_qr_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`任意のテキストやリンクをQRコードに変換し、PNGとしてダウンロードできます。すべてブラウザ内で処理され、データはアップロードされません。`)
};

const zh_qr_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`将任意文本或链接转换为二维码，并下载为 PNG。全部过程都在你的浏览器中完成——不会上传任何内容。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const qr_intro = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.qr_intro(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("qr_intro", locale)
	if (locale === "en") return en_qr_intro(inputs)
	if (locale === "es") return es_qr_intro(inputs)
	if (locale === "de") return de_qr_intro(inputs)
	if (locale === "nl") return nl_qr_intro(inputs)
	if (locale === "fr") return fr_qr_intro(inputs)
	if (locale === "it") return it_qr_intro(inputs)
	if (locale === "pt-BR") return pt_br2_qr_intro(inputs)
	if (locale === "pt") return pt_qr_intro(inputs)
	if (locale === "ja") return ja_qr_intro(inputs)
	return zh_qr_intro(inputs)
};